/**
 * UserAvatar — аватар пользователя. Один компонент на весь сайт.
 *
 * Зачем. Эта разметка была продублирована в 19 местах: тернарник
 * «есть фото → <img>, нет → <span> с буквой и цветом из хеша имени»
 * плюс свой класс размера в каждом экране. Отсюда расхождения, которые
 * никто не замечал: в топе аватар квадратный, в друзьях круглый,
 * в профиле буква другого кегля, где-то нет alt, где-то нет
 * object-fit и фото растягивается.
 *
 * Правила из дизайн-системы:
 *  • цвет заглушки ДЕТЕРМИНИРОВАН по имени — при перезагрузке тот же;
 *  • кегль буквы пропорционален размеру (0.42), а не фиксирован;
 *  • flex:none — аватар не сжимается, когда рядом длинный ник;
 *  • loading="lazy" — в списках их бывает по сотне.
 *
 * frame — ключ купленной рамки. Обёртка AvatarFrame подключается только
 * когда рамка реально есть: она рисует анимированные кольца, и вешать
 * её на каждый аватар в списке из 100 строк незачем.
 */
import React from "react";
import AvatarFrame from "./AvatarFrame";
import { avatarInitialColor } from "./cabinetUtils";
import "../../styles/user-avatar.css";

export default function UserAvatar({
  name,
  photo,
  size = 40,
  frame,
  thickness = 3,
  className = "",
  title,
}) {
  const label = String(name || "?");
  const initial = label.trim().charAt(0).toUpperCase() || "?";

  const inner = photo ? (
    <img
      src={photo}
      alt=""
      loading="lazy"
      decoding="async"
      className={`rb-ava__img ${className}`}
      style={{ width: size, height: size }}
      title={title}
    />
  ) : (
    <span
      className={`rb-ava__letter ${className}`}
      style={{
        width: size,
        height: size,
        background: avatarInitialColor(label),
        // Кегль от размера: фиксированный 30px на аватаре 28px вылезал
        // за круг, а на 80px терялся в середине.
        fontSize: Math.round(size * 0.42),
      }}
      title={title}
      aria-hidden="true"
    >
      {initial}
    </span>
  );

  if (!frame || frame === "none") return inner;

  return (
    <AvatarFrame frame={frame} size={size + thickness * 2} thickness={thickness}>
      {inner}
    </AvatarFrame>
  );
}
